import React from "react";
export default function Footer(props) {
 return (
  <div className="footer">
   Created by <a href="https://github.com/mehdi-touil/">Mehdi Touil</a> for The
   odin Project || copyright © 2022 all rights reserved
  </div>
 );
}
